import { Injectable } from "@angular/core";
import SockJS from "sockjs-client";
import { Client, IMessage } from "@stomp/stompjs";
import { Observable, Subject, Subscription } from "rxjs";
import { ApplicationHttpService } from "../../../../shared/services/application-http.service";
import { environment } from "../../../../../../environments/environment";
import { Notification, NotificationRequest } from "../../../notifications/notifications/notifications.component";
import { StorageService } from "../../../../../account/services/storage.service";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
    //@ts-ignore
    token: string;
    //@ts-ignore
    userId: string;
    isConnected: boolean = false;
    public count: number = 0;

    public updateCount$ = new Subject<number>();

    //@ts-ignore
    private client: Client;
    private readonly url = `${environment.apiExtEndpoint}ws`;

    constructor(private storageService: StorageService, private http: ApplicationHttpService) {}
    //@ts-ignore
    receiptId: string;

    //@ts-ignore
    selectedItem: Notification;
    public showNotificationModal$ = new Subject<number>();
    public showNotificationContent$ = new Subject<number>();

    connect() {
        this.token = this.storageService.getToken()!;
        this.userId = this.storageService.getUser()?.sub;
        console.log(this.userId);

        this.client = new Client({
            webSocketFactory: () => new SockJS(this.url),
            connectHeaders: {
                Authorization: `Bearer ${this.token}`
            },
            reconnectDelay: 5000,
            onConnect: () => {
                console.log('Successful connection to socket!');
                this.isConnected = true;
                this.connectToTopicCount();
            },
            onDisconnect: () => {
                this.isConnected = false;
            },
            onStompError: () => {
                this.isConnected = false;
            },
            onWebSocketError: (error: string) => {
                console.error(error);
            },
            // debug: (msg: string) => {
            //     console.log(msg);
            // },
        });

        this.client.activate();
    }

    connectToTopicCount() {
        this.client.subscribe(`/user/${this.userId}/queue/notifications/count`, this.onMessageReceived);
        this.notificationCount().subscribe(count => {
            this.count = count;
            this.updateCount$.next(count);
        })
    }

    onMessageReceived = (message: IMessage) => {
        const body = JSON.parse(message.body);
        console.log('Получено сообщение: ', body);
        this.count = body;
        this.updateCount$.next(body);
    };

    notifications(request?: NotificationRequest): Observable<any> {
        return this.http.post(`${environment.apiExtEndpoint}api/v1/user-notification/load${request?.getUrl()}`, null);
    }

    notificationCount(): Observable<any> {
        return this.http.get(`${environment.apiExtEndpoint}api/v1/user-notification/count`);
    }

    setIsRead(id: number): Observable<any> {
        return this.http.put(`${environment.apiExtEndpoint}api/v1/user-notification/set-status-seen/${id}`, null);
    }

    setIsReadAll(): Observable<any> {
        return this.http.put(`${environment.apiExtEndpoint}api/v1/user-notification/set-status-seen/all`, null);
    }
}
